import { useQueryClient } from '@tanstack/react-query';
import { Dropdown } from '@wot/components';
import { ITutor, ITutorLevel } from '@wot/typings';
import { parseISO } from 'date-fns';
import { format } from 'date-fns/esm';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import tutorsApi from '../../../../api/tutors';
import { ARROWDOWN_ICON } from '../../../../assets/icons';
import { DropDownItem, MenuProps } from '../../../../components/DropDown';
import ModalContainer, { ConfirmationBox } from '../../../../components/Modal';
import { TableRowItemData } from '../../../../components/Table';
import xhr from '../../../../utils/fetch';

export function TableRowItem({ tutor, setTutor }: { tutor: ITutor, setTutor?: React.Dispatch<React.SetStateAction<ITutor | undefined>> }) {
  const queryClient = useQueryClient();
  const [statusOptions, setStatusOptions] = useState<MenuProps[]>([]);
  const [levelOptions, setLevelOptions] = useState<MenuProps[]>([]);
  const navigate = useNavigate();

  const sendToRevision = () => {
    if (
      tutor.personal.status === 'issue' ||
      tutor.education.status === 'issue' ||
      tutor.experience.status === 'issue' ||
      tutor.profession.status === 'issue'
    ) {
      tutorsApi.updateProfile(tutor._id, {
        status: 'revision'
      }).then(() => setTutor && setTutor({ ...tutor, status: "revision" }));
      queryClient.invalidateQueries({ queryKey: ['manage-tutors'] });
    } else {
      toast.error('No Issues Found');
    }
  };
  const sendToRejected = () => {
    tutorsApi.updateProfile(tutor._id, {
      status: 'blocked'
    }).then(() => setTutor && setTutor({ ...tutor, status: "blocked" }));
    queryClient.invalidateQueries({ queryKey: ['manage-tutors'] });
    toast.success('Tutor Blocked');
  };
  const sendToActive = () => {
    // if (!tutor.calender) {
    //   toast.error('Tutor has not set the calendar.');
    //   return;
    // }
    tutorsApi.updateProfile(tutor._id, {
      status: 'active'
    }).then(() => setTutor && setTutor({ ...tutor, status: "active" }));
    queryClient.invalidateQueries({ queryKey: ['manage-tutors'] });
    toast.success('Tutor is now active');
  };
  const sendToInActive = () => {
    tutorsApi.updateProfile(tutor._id, {
      status: 'in-active'
    }).then(() => setTutor && setTutor({ ...tutor, status: "in-active" }));
    queryClient.invalidateQueries({ queryKey: ['manage-tutors'] });
    toast.success('Tutor sent to inactive');
  };

  const updateTutorLevel = (level: ITutorLevel) => {
    tutorsApi.updateAgreement({
      _id: tutor._id,
      data: {
        // @ts-ignore
        agreement: {
          ...tutor.agreement,
          level: level
        }
      }
    }).then(() => {
      setTutor && setTutor({
        ...tutor,
        // @ts-ignore
        agreement: {
          ...tutor.agreement,
          level: level
        }
      })
      queryClient.invalidateQueries({ queryKey: ['manage-tutors'] });
      toast.success('tutor level updated.');
    })
      .catch(() => {
        toast.error('Something went wrong.');
      });
  };

  useEffect(() => {
    let items: MenuProps[] = [];
    if (tutor.status === 'under-review') {
      items = [
        {
          key: 1,
          label: (
            <ModalContainer
              ModalComp={<ConfirmationBox text="Confirm Move to Revision?" onConfirm={() => sendToRevision()} />}
            >
              <DropDownItem label="Revision" />
            </ModalContainer>
          )
        },
        {
          key: 2,
          label: (
            <ModalContainer
              ModalComp={<ConfirmationBox text="Confirm Move to Active?" onConfirm={() => sendToActive()} />}
            >
              <DropDownItem label="Active" />
            </ModalContainer>
          )
        },
        {
          key: 3,
          label: (
            <ModalContainer
              ModalComp={<ConfirmationBox text="Confirm Move to In-Active?" onConfirm={() => sendToInActive()} />}
            >
              <DropDownItem label="In Active" />
            </ModalContainer>
          )
        },
        {
          key: 4,
          label: (
            <ModalContainer
              ModalComp={<ConfirmationBox text="Confirm Move to Blocked?" onConfirm={() => sendToRejected()} />}
            >
              <DropDownItem label="Block" />
            </ModalContainer>
          )
        }
      ];
      setStatusOptions(items);
      return;
    }

    if (tutor.status === 'revision') {
      items = [
        {
          key: 1,
          label: (
            <ModalContainer
              ModalComp={<ConfirmationBox text="Confirm Move to Blocked?" onConfirm={() => sendToRejected()} />}
            >
              <DropDownItem label="Block" />
            </ModalContainer>
          )
        }
      ];
      setStatusOptions(items);
      return;
    }

    if (tutor.status === 'rev-agreement') {
      items = [
        {
          key: 1,
          label: (
            <ModalContainer
              ModalComp={<ConfirmationBox text="Confirm Move to Blocked?" onConfirm={() => sendToRejected()} />}
            >
              <DropDownItem label="Block" />
            </ModalContainer>
          )
        }
      ];
      setStatusOptions(items);
      return;
    }

    if (tutor.status === 'active') {
      items = [
        {
          key: 1,
          label: (
            <ModalContainer
              ModalComp={<ConfirmationBox text="Confirm Move to In Active?" onConfirm={() => sendToInActive()} />}
            >
              <DropDownItem label="In Active" />
            </ModalContainer>
          )
        },
        {
          key: 2,
          label: (
            <ModalContainer
              ModalComp={<ConfirmationBox text="Confirm Move to Blocked?" onConfirm={() => sendToRejected()} />}
            >
              <DropDownItem label="Block" />
            </ModalContainer>
          )
        }
      ];
      setStatusOptions(items);
      return;
    }

    if (tutor.status === 'in-active') {
      items = [
        {
          key: 1,
          label: (
            <ModalContainer
              ModalComp={<ConfirmationBox text="Confirm Move to In Active?" onConfirm={() => sendToActive()} />}
            >
              <DropDownItem label="Active" />
            </ModalContainer>
          )
        },
        {
          key: 2,
          label: (
            <ModalContainer
              ModalComp={<ConfirmationBox text="Confirm Move to Blocked?" onConfirm={() => sendToRejected()} />}
            >
              <DropDownItem label="Block" />
            </ModalContainer>
          )
        }
      ];
      setStatusOptions(items);
      return;
    }

    if (tutor.status === 'blocked') {
      items = [
        {
          key: 1,
          label: (
            <ModalContainer
              ModalComp={<ConfirmationBox text="Confirm Move to Active?" onConfirm={() => sendToActive()} />}
            >
              <DropDownItem label="Active" />
            </ModalContainer>
          )
        }
      ];
      setStatusOptions(items);
      return;
    }
  }, [tutor.status]);

  useEffect(() => {
    if (tutor.agreement?.level === 'standard') {
      setLevelOptions([
        {
          key: 1,
          label: (
            <ModalContainer
              ModalComp={
                <ConfirmationBox
                  text="Are you sure want to set this tutor as premium?"
                  onConfirm={() => updateTutorLevel('premium')}
                />
              }
            >
              <DropDownItem label="Premium" />
            </ModalContainer>
          )
        }
      ]);
    } else {
      setLevelOptions([
        {
          key: 1,
          label: (
            <ModalContainer
              ModalComp={
                <ConfirmationBox
                  text="Are you sure want to set this tutor as standard?"
                  onConfirm={() => updateTutorLevel('standard')}
                />
              }
            >
              <DropDownItem label="Standard" />
            </ModalContainer>
          )
        }
      ]);
    }
  }, []);

  return (
    <>
      <TableRowItemData onClick={() => navigate(tutor._id)} text={format(parseISO(tutor.createdAt), 'dd/MM/yyyy')} />
      <TableRowItemData onClick={() => navigate(tutor._id)} text={tutor._id} />
      <TableRowItemData onClick={() => navigate(tutor._id)} text={tutor?.personal?.data?.name} />
      <TableRowItemData onClick={() => navigate(tutor._id)} text={tutor?.personal?.data?.email} />
      <TableRowItemData onClick={() => navigate(tutor._id)} text={tutor?.personal?.data?.phoneNumber} />
      <TableRowItemData
        component={
          <div className="w-full flex items-center justify-between">
            <Dropdown menu={levelOptions} placement="bottomLeft">
              <div
                className={`bg-[#B6CFFF] text-[#2B5297] w-full flex items-center justify-between gap-4 px-4 py-1 rounded-full cursor-pointer`}
              >
                <p className="text-sm font-semibold">{tutor.agreement?.level}</p>
                <img src={ARROWDOWN_ICON} className={`w-4`} />
              </div>
            </Dropdown>
          </div>
        }
      />
      <TableRowItemData
        component={
          <div className="w-full flex items-center justify-between">
            <Dropdown menu={statusOptions} placement="bottomRight">
              <div
                className={`${tutor.status === 'active' ? 'bg-[#D2FFC7] text-[#498839]' : ''} ${tutor.status === 'blocked' ? 'bg-[#E9EDF5] text-[#5A6376]' : ''
                  } ${tutor.status === 'under-review' ? 'bg-[#FFE1C9] text-[#BA5300]' : ''} ${tutor.status === 'rev-agreement' ? 'bg-[#EEFCE0] text-[#498839]' : ''
                  } ${tutor.status === 'revision' ? 'bg-[#DAFDFF] text-[#006B72]' : ''} ${tutor.status === 'in-active' ? 'bg-[#FFE1C9] text-[#BA5300]' : ''
                  } w-full flex items-center justify-between gap-2 px-4 py-1 rounded-full cursor-pointer`}
              >
                <p className="text-sm font-semibold">{tutor.status}</p>
                <img src={ARROWDOWN_ICON} alt="Open status menu" className={`w-4`} />
              </div>
            </Dropdown>
          </div>
        }
      />
    </>
  );
}

// ${status === "under-review" && "bg-[#FFE1C9] text-[#BA5300]"}
// ${status === "revision" && "bg-[#DAFDFF] text-[#006B72] "}
// ${status === "gen-agreement" && "bg-[#E9EDF5] text-[#5A6376]"}
// ${status === "rev-agreement" && "bg-[#EEFCE0] text-[#498839]"}
// ${status === "rejected" && "bg-[#EEFCE0] text-[#498839]"}
